module.exports = __webpack_public_path__ + "static/media/question.802b9e82.png";